<ng-container *ngIf="isSandboxCard; else showServiceCard">
  <app-sandbox-card [sandbox]="sandbox" class="w-100-percent"></app-sandbox-card>
</ng-container>
<ng-template #showServiceCard>
  <app-service-card [serviceCardInfo]="serviceCardInfo" class="w-100-percent"></app-service-card>
</ng-template>
